<script lang="ts" setup>

import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'

import type { Props } from './types'

const { t } = useI18n()

const props = defineProps<Props>()

const companyName = props.listing?.raw_listing?.companies?.[0]?.company_name

</script>

<script lang="ts">
export default {
  name: 'VerificationBanner'
}
</script>

<template>
  <section
    class="verification-banner relative flex flex-col items-center mt-72 mt-0 px-24 lg:px-90 py-64 lg:py-100">
    <div class="la-haus-verified-logo flex flex-row justify-center gap-4">
      <RoomieTag
        id="la-haus-verified-tag"
        variant="information"
        label=""
        size="lg">
        <template #icon>
          <img src="https://assets.lahaus.com/static/svgs/icons/LaHausVerificadoLogo_2.svg"></img>
        </template>
      </RoomieTag>
    </div>

    <div class="text-center mt-16 lg:mt-24 text-pine-600">
      <div class="subtitle display-8 lg:display-6">
        {{ t('subtitle') }}
      </div>

      <div class="display-6 lg:display-4 mt-4">
        {{ companyName }}
      </div>
    </div>

    <div class="la-haus-verification-advantages flex flex-col lg:flex-row justify-center gap-16 mt-40 mb-0 lg:mt-56 items-stretch">
      <div class="frame flex flex-col">
        <img src="https://assets.lahaus.com/static/svgs/icons/Tick_2.svg"></img>

        <span class="my-16 hl-3-sb lg:display-7">{{ t('firstBoxTitle') }}</span>

        <span class="body-1-m lg:body-1-sb">{{ t('firstBoxSubtitle') }}</span>
      </div>

      <div class="frame flex flex-col">
        <img src="https://assets.lahaus.com/static/svgs/icons/Tick_2.svg"></img>

        <span class="my-16 hl-3-sb lg:display-7">{{ t('secondBoxTitle') }}</span>

        <span class="body-1-m lg:body-1-sb">{{ t('secondBoxSubtitle') }}</span>
      </div>

      <div class="frame flex flex-col">
        <img src="https://assets.lahaus.com/static/svgs/icons/Tick_2.svg"></img>

        <span class="my-16 hl-3-sb lg:display-7">{{ t('thirdBoxTitle') }}</span>

        <span class="body-1-m lg:body-1-sb">{{ t('thirdBoxSubtitle') }}</span>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.verification-banner {
  background-color: var(--color-gray-400);

  .la-haus-verified-logo {
    gap: 0.48rem;
  }

  .la-haus-verification-advantages {
    .frame {
      width: 100%;
      border-radius: 24px;
      background-color: var(--color-white);
      padding: 2.4rem;

      @media (width >= 1024px) {
        max-width: 35.6rem;
      }

      img {
        width: 28px;
        height: 46.308px;

        @media (width >= 1024px) {
          width: 43.577px;
          height: 72.07px;
        }
      }

      span {
        @apply text-pine-600;
      }
    }
  }

  #la-haus-verified-tag {
    @apply py-12 px-18;

    min-height: 3.3rem;
    max-height: 3.3rem;

    img {
      width: 16.4rem;
      height: 1.6rem;
    }

    @media (width >= 1024px) {
      @apply py-14 px-22;

      min-height: 5rem;

      img {
        width: 19.7rem;
        height: 1.9rem;
      }
    }
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
